import bootstrapper from '../bootstrapper';

const prodEnvironment = () => {
  const mockedEnvs = ['test', 'development'];
  return !mockedEnvs.includes(bootstrapper.appEnv);
};

export default () => {
  if (prodEnvironment() && bootstrapper.clarityEnabled) {
    const initClarity = function (screen, doc, clarity, script, key) {
      const buildClarityArgs = function (...args) {
        (screen[clarity].q = screen[clarity].q || []).push(args);
      };
      screen[clarity] = screen[clarity] || buildClarityArgs;
      const t = doc.createElement(script);
      t.async = true;
      t.src = `https://www.clarity.ms/tag/${key}`;
      const [y] = doc.getElementsByTagName(script);
      y.parentNode.insertBefore(t, y);
    };

    initClarity(window, document, 'clarity', 'script', bootstrapper.clarityKey);
  }
};
